import API, { graphqlOperation } from '@aws-amplify/api'
import loader from './loader'
import { indexer, getFiltersFromState } from 'helpers/'

/**
 * List of action strings
 *
 * @type {object}
 */
export const ACTION = {
  GET_SUGGESTIONS: 'get-suggestions',
  GET_SUGGESTION: 'get-suggestion'
}

/**
 * List of loading action strings
 *
 * @type {object}
 */
export const LOAD = {
  ...ACTION
}

/**
 * GraphQL queries
 */
export const queries = {
  getSuggestion: `
    query ($id: Int!) {
      getSuggestion (id: $id) {
        id
        email
        created
        text
        type,
        attachments
      }
    }
  `,
  getSuggestions: `
    query ($start: Int, $fetch: Int) {
      getSuggestions (type: SUGGESTION, start: $start, fetch: $fetch) {
        count
        data {
          id
          email
          created
          text
          type
        }
      }
    }
  `
}

export const getSuggestion = (id) => {
  return loader.load(LOAD.GET_SUGGESTION, (dispatch) => {
    return API.graphql(graphqlOperation(queries.getSuggestion, { id }))
      .then((result) => dispatch({ type: ACTION.GET_SUGGESTION, id, data: result.data.getSuggestion }))
  })
}

export const getSuggestions = () => {
  return loader.load(LOAD.GET_SUGGESTIONS, (dispatch, getState) => {
    const filters = getFiltersFromState(getState())

    return API.graphql(graphqlOperation(queries.getSuggestions, filters))
      .then((result) => dispatch({ type: ACTION.GET_SUGGESTIONS, ...result.data.getSuggestions }))
  })
}

export const reducer = (state = {
  data: [],
  count: 0,
  byId: {}
}, action) => {
  switch (action.type) {
    case ACTION.GET_SUGGESTION:
      return {
        ...state,
        count: action.count,
        byId: {
          ...state.byId,
          [action.id]: action.data
        }
      }
    case ACTION.GET_SUGGESTIONS:
      return {
        ...state,
        count: action.count,
        data: action.data,
        byId: indexer(action.data, 'id')
      }
    default:
      return state
  }
}